<script>
import materialOrderApi from '@/api/materialOrder';

import Default from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';

export default {
  name: 'ExchangeDecorList',
  components: {
    CommonSection,
    Default,
  },
  data() {
    return {
      orders: [],
    };
  },
  mounted() {
    materialOrderApi.fetchList({}, true).then(r => { this.orders = r.items; });
  },
};
</script>

<template lang="pug">
  Default()
    CommonSection(title="Биржа")
      .orders
        router-link.order(
          v-for="order in orders"
          :key="order.id"
          :to="{ name: 'exchange-order-detail', params: { orderId: order.id } }"
        ) [{{ order.id }}] {{ order.name }}

</template>

<style scoped lang="scss">
  .orders {
    display: grid;
    gap: 30px;
  }

  .order {
    padding: 30px;
    border-radius: 30px;
    border: 1px solid black;
  }
</style>
